import { apiConcurso } from './cliente';

export const getBootstrap = () => apiConcurso.get('/api/v1/bootstrap');
